define([
  "helpers",
  "jquery",
  "knockout"],
function(helpers, $, ko) {

  "use strict";

  ko.bindingHandlers.configuratorZone = {

    init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {

      var groupName = valueAccessor();
      var options;
      var template = "option-groups/" + groupName;
        var productConfiguration;
        if (bindingContext.$parents.length === 0) {
            //in this scenario, currently only on the two override templates for blinds ca install (502796-7) we are the root view model
            productConfiguration = bindingContext.$data;
        } else {
            productConfiguration = bindingContext.$parent;
        }

      if (groupName === "Ungrouped") {
          options = productConfiguration.ungroupedOptions();
      } else {
          options = productConfiguration.optionsByGroupName(groupName);
        if (options.length < 1) {
          $(element).hide();
        }
      }

      ko.applyBindingsToNode(element, {
        template: {
          name: template,
          data: options
        }
      }, bindingContext);
    return { controlsDescendantBindings: true };
    }
  };

});
